// removed by extract-text-webpack-plugin
module.exports = {"loader":"loader__20ouB","glow":"glow__1AaT4"};


//////////////////
// WEBPACK FOOTER
// ./components/loader/style.scss
// module id = OcWS
// module chunks = 13